<style lang="scss" scoped>
  @import "details";
  .promotionDetail{
    p{
      font-size: 12px;
    }
  }
  .search-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-form-item{
      margin-bottom:0;
    }
  }
  .product{
    display: flex;
    align-items: center;
    .redFlag {
      background: #FF2E2E;
      color: #fff;
      width: 80px;
      margin-top: -20px;
      position: absolute;
      z-index: 50;
      text-align: center;
      font-size: 11px;
      line-height: 18px;
    }
    .info{
      margin-left: 20px;
      text-align: left;
      flex:1;
    }
    .title{
      font-size: 16px;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  .el-input-number{
    width:120px;
  }
  .goods-details{
    width: 100%;
    display: flex;
    align-items: center;
    .l-title{
      width:249px;
    }
    ul{
      min-height: 90px;
      width: 100%;
      // border-left: 1px solid #eee;
    }
    li{
      display: flex;
      align-items: center;
      text-align: left;
      border-bottom: 1px solid #eee;
      padding:10px 20px;
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
      &:last-child{
        border:0;
      }
    }
    .img-box{
      width:80px;
      height:80px;
      margin-right: 20px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 100%;
      }
    }
    dl{
      display: flex;
      flex-wrap: wrap;
      dd{
        width:50%;
        margin-top: 5px;
      }
    }
    label{
      color:#999;
    }
  }

  .productListTitle{
    margin-top: 20px;
    width: 100%;
    line-height: 40px;
    border-top: 1px solid #EBEEF5;
    border-left: 1px solid #EBEEF5;
    td{
      background: rgb(247, 249, 250);
      padding: 5px;
      text-align: center;
      font-weight: bold;
      font-size: 12px;
      border-right: 1px solid #EBEEF5;
    }
  }

  .productListTitle2{
    margin-top: 20px;
    width: 100%;
    line-height: 40px;
    border-top: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    border-left: 1px solid #EBEEF5;
    td{
      background: rgb(247, 249, 250);
      padding: 5px;
      text-align: center;
      font-weight: bold;
      font-size: 12px;
      border-right: 1px solid #EBEEF5;
    }
  }
</style>
<style lang="scss">
  .user-details .el-table__expanded-cell[class*=cell]{
    padding:0 !important;
  }
  .cons{
    display: none;
  }
  @media screen and (max-width: 640px){
    .container{
      width: 90% !important;
      font-size: 12px!important;
    }
    .con{
      display: none!important;
    }
    .cons{
      padding: 15px;
      display: block!important;
    }
    .text-lists {
      display: block!important;
    }
    .text-lists li {
      width: 100% !important;
    }
    .container h3.title {
      font-size: 20px !important;
    }
    .product{
      .redFlag{
        width: 75px!important;
      }
    }
  }
  @media screen and (max-width: 640px) {
  .el-message-box {
    width: 90% !important;
  }
}
</style>
<template>
  <div class="user-details" v-loading="loading">
    <section class="container con">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/user' }">用户中心</el-breadcrumb-item>
        <el-breadcrumb-item><router-link to="/user/molecular">擎科科邦邦商城订单</router-link></el-breadcrumb-item>
        <el-breadcrumb-item>擎科科邦邦商城订单详情</el-breadcrumb-item>
      </el-breadcrumb>
      <h3 class="title">擎科科邦邦商城订单详情<span :style="{fontSize: '14px', marginLeft: '20px', cursor: 'pointer'}"><a @click="viewContract">《服务协议》</a></span></h3>
      <ul class="text-lists">
        <li v-show="isHeadMan"><span>关联用户：</span>{{details.customer&&details.customer.realName}}</li>
        <li><span>订单创建者：</span>{{details.customer&&details.customer.realName}}</li>
<!--        <li><span>订单号：</span>{{details.code}}</li>-->
        <li><span>实验基地：</span>{{details.base&&details.base.name}}</li>
        <li><span>订单创建时间：</span>{{details.createTime | rTime}}</li>

        <li><span>收货地址：</span>{{address}}</li>
<!--        <li><span>订单状态：</span>{{details.statusName}}</li>-->
<!--        <li><span>结算状态：</span>{{details.payStatusName}}</li>-->
<!--        <li><span>订单总金额：</span>{{details.amount | amount}} 元</li>-->
      </ul>
      <el-button type="primary" size="small" v-show="details.exchangeGoodsFlag" @click="exchangeOrder(details)">确认换货</el-button>
      <el-button type="primary" size="small" @click="confirmVisible"  v-show="details.statusName === '待确认' && memberInfo.id === details.customer.id">确认订单</el-button>
      <el-button type="primary" size="small" @click="cancelVisible"  v-show="['待确认','待审核'].indexOf(details.statusName) > -1 && memberInfo.id === details.customer.id">取消订单</el-button>
      <el-tooltip :content="content" placement="top" effect="light" :disabled="!details.exchangeGoodsFlag">
      <el-button type="primary" size="small" @click="openSend(index)" v-show="details.statusName === '部分发货' || details.statusName === '未发货' &&memberInfo.id === details.customer.id"
        :disabled="details.exchangeGoodsFlag">发货</el-button>
      </el-tooltip>
       <!-- <el-button type="primary" @click="openSend(index)">发货</el-button>
       <el-button @click="deliveryReminder">1213</el-button> -->
      <div style="margin-top: 10px;">注：客户应自收到发票之日起3个月内支付费用，双方有其他约定的以另行约定为准</div>
      <el-table
        border
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
        class="mt20"
        :data="orderInfoList">
        <el-table-column
          prop="code"
          width="240"
          label="订单编号">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="订单商品总金额">
          <template slot-scope="scope">
            {{ scope.row.goodsAmount | amount }}
          </template>
        </el-table-column>
         <!-- v-if="orderInfoList[0]&&(orderInfoList[0].promotionAmount > 0 || orderInfoList[0].totalStaffAdjustPriceDiscount)" -->
        <el-table-column
          v-if="orderInfoList[0]&&(orderInfoList[0].promotionAmount > 0)"
          prop="amount"
          min-width="160"
          label="促销折扣金额">
          <template slot-scope="scope">
           <!-- {{(scope.row.promotionAmount / 1 + (0-((scope.row.totalStaffAdjustPriceDiscount? scope.row.totalStaffAdjustPriceDiscount: 0)  / 1)) >= 0) ? '-' : '+'}}
           {{Math.abs(scope.row.promotionAmount + (0-((scope.row.totalStaffAdjustPriceDiscount? scope.row.totalStaffAdjustPriceDiscount: 0) / 1))) | amount}}
            -->
           - {{details.promotionAmount | amount}}

            <div class="promotionDetail">
              <p v-if="scope.row.totalAmountOffDiscount && scope.row.totalAmountOffDiscount !== 0">满减活动：{{ scope.row.totalAmountOffDiscount | amount }}</p>
              <p v-if="scope.row.totalFixPriceDiscount && scope.row.totalFixPriceDiscount !== 0">固定金额活动：{{ scope.row.totalFixPriceDiscount | amount }}</p>
<!--              <p v-if="scope.row.totalSellerUnitPriceDiscount !== 0">销售改价：{{ scope.row.totalSellerUnitPriceDiscount | amount }}</p>-->
              <!-- <p v-if="scope.row.totalStaffAdjustPriceDiscount && scope.row.totalStaffAdjustPriceDiscount !== 0">人工改价：{{scope.row.totalStaffAdjustPriceDiscount> 0 ? '+' : ''}}{{ scope.row.totalStaffAdjustPriceDiscount | amount }}</p> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="orderInfoList[0]&&orderInfoList[0].returnAmount > 0"
          prop="amount"
          label="订单退款金额">
          <template slot-scope="scope">
            {{ scope.row.returnAmount | amount }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="orderInfoList[0]&&(orderInfoList[0].promotionAmount > 0 || orderInfoList[0].totalStaffAdjustPriceDiscount !== 0)"
          prop="amount"
          label="订单应付金额">
          <template slot-scope="scope">
            {{ scope.row.amount | amount }}
          </template>
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="订单状态">
        </el-table-column>
        <el-table-column
          prop="payStatusName"
          label="结算状态">
        </el-table-column>
        <el-table-column
          prop="unlockPoints"
          label="已解锁积分">
          <template slot-scope="scope">
            <div class="flex flex-justify-start flex-direction-col">
              <span>{{scope.row.unlockPoints}}</span>
              <span v-if="scope.row.totalDeductUnlockPoints > 0" :style="{color: '#FF2222'}">退货扣除：{{scope.row.totalDeductUnlockPoints}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="lockPoints"
          label="未解锁积分">
          <template slot="header">
            <span>未解锁积分</span>
            <el-tooltip class="item" effect="dark" content="本次赠送积分，以最终订单结算为准" placement="top">
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div class="flex flex-justify-start flex-direction-col">
              <span>{{scope.row.lockPoints}}</span>
              <span v-if="scope.row.totalDeductLockPoints > 0" :style="{color: '#FF2222'}">退货扣除：{{scope.row.totalDeductLockPoints}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="配送状态">
        </el-table-column>
      </el-table>
      <div>
        <table
          cellspacing= 0 cellpadding= 0
          :class="this.productTableShow ? 'productListTitle' : 'productListTitle2'">
          <tr>
            <td>
              <div :style="{width: '100%'}">
                <span style="float: left;margin-left: 10px;cursor: pointer" @click="viewTable">
                  <i v-if="productTableShow" class="el-icon-arrow-down" />
                  <i v-else class="el-icon-arrow-right" />
                </span>
                <span>产品信息</span>
              </div>
            </td>
            <td :style="{width: '180px'}">单价</td>
            <td :style="{width: '180px'}">数量</td>
            <td :style="{width: '180px'}">未发货商品数量</td>
          </tr>
        </table>
      </div>
      <el-table
        v-show="productTableShow"
        border
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
        :cell-class-name="rowClass"
        :data="goodsLists"
        :showHeader="false"
      >
        <el-table-column
          prop="name"
          label="产品信息"
        >
          <template slot="header">
            <div>
              <span :style="{float: 'left', cursor: 'pointer'}"
                @click="viewTable"
              >
                <i class="el-icon-arrow-down" />
              </span>
              <span>产品信息</span>
            </div>

          </template>
          <template slot-scope="scope">
            <div class="product">
              <div>
                <img :src="scope.row.imgUrl" style="width:80px;">
                <div v-if="scope.row.syzFlag / 1 === 1" class="redFlag">试用装</div>
                <div v-else-if="scope.row.price==0" class="redFlag">赠品</div>
              </div>

              <div class="info">
                <el-tooltip class="item" effect="dark" :content="scope.row.name"  placement="top-start">
                  <div class="title" >{{scope.row.name}}</div>
                </el-tooltip>
                <p>规格：{{scope.row.spec}}</p>
                <p>货号：{{scope.row.skuCode ? scope.row.skuCode : '-'}}</p>
                <p>单位：{{scope.row.skuUnit ? scope.row.skuUnit : '-'}}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="单价"
          width="180"
        >
          <template slot-scope="scope">{{scope.row.priceY | regDecimalPoint}}</template> 
        </el-table-column>
        <el-table-column
          prop="needPayQuantity"
          label="数量"
          width="180"
        >
          <template slot-scope="scope">
            <div>{{scope.row.needPayQuantity}}</div>
            <div style="color: #FF2E2E" v-if="scope.row.postSaleQuantity">该商品已退货：{{scope.row.postSaleQuantity}}件</div>

          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          label="应付金额（元）">-->
<!--          <template slot-scope="scope">{{scope.row.amount | amount}}</template>-->
<!--        </el-table-column>-->
        <el-table-column
          label="未发货商品数量"
          width="180"
        >
          <template slot-scope="scope">
            {{scope.row.needSendQuantity}}
          </template>
        </el-table-column>
      </el-table>
      <el-tabs v-model="activeName" style="margin-top:20px">
        <el-tab-pane v-for="(item, index) in tabPaneList" :key="index" :label="item.label" :name="item.name">
          <ExchangeRecord v-show="item.name === '3'" :mallExchangeGoods="mallExchangeGoods"/>
        </el-tab-pane>
      </el-tabs>
      <!-- <h3 class="title distribution-title" @click="showDistribution = !showDistribution">配送记录<span class="el-icon-arrow-down" :class="{active: !showDistribution}"></span></h3> -->
      <div v-show="activeName === '1'">
        <el-table
          :data="sendLists"
          border>

          <el-table-column
            label="配送单号"
            width="260px"
            prop="code">
          </el-table-column>
          <el-table-column
            prop="sendStatusName"
            width="110px"
            label="配送状态">
          </el-table-column>
          <el-table-column
            label="配送方式"
            width="110px"
            prop="sendTypeName">
          </el-table-column>
          <el-table-column
            width="120px"
            label="配送员/运单号">
            <template slot-scope="scope">
              <div v-if="scope.row.sendType !== 'DELIVERY'">{{scope.row.sender && scope.row.sender.realName}}</div>
              <div v-else>{{scope.row.deliveryCode}}</div>
            </template>
          </el-table-column>
          <el-table-column
            width="120px"
            label="配送完成时间">
            <template slot-scope="scope">{{scope.row.finishSendDate | rTime}}</template>
          </el-table-column>
          <el-table-column
            label="配送完成时间">
            <template slot-scope="scope">
              <div class="goods-details">
                <ul>
                  <li v-for="item in scope.row.items" :key="item.id">
                    <div class="img-box">
                      <img :src="item.imgUrl">
                    </div>
                    <div class="info">
                      <div class="title">{{item.goodsName}}</div>
                      <dl>
                        <dd><label>规格：</label>{{item.spec}}</dd>
                        <dd><label>商品数量：</label>{{item.quantity}}</dd>
                        <dd><label>货号：</label>{{item.skuCode}}</dd>
                        <dd><label>单位：</label>{{item.skuUnit}}</dd>
                      </dl>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="page tr">
          <el-pagination
            layout="prev, pager, next"
            :total="sendTotal"
            @current-change="changeSendPage">
          </el-pagination>
        </div>
      </div>
      <!--退货记录-->
      <!-- <h3 v-if="returnList.length > 0" class="title distribution-title" @click="showReturned = !showReturned">退货记录<span class="el-icon-arrow-down" :class="{active: !showReturned}"></span></h3> -->
      <div v-show="activeName === '2'">
        <el-table
          :data="returnList"
          border>
          <el-table-column
            label="时间"
            width="180"
          >
            <template slot-scope="scope">
              {{scope.row.startDate | rTime}}
            </template>
          </el-table-column>
          <el-table-column
            label="产品信息"
            :min-width="320"
          >
            <template slot-scope="scope">
              <div class="flex flex-justify-start">
                <img :src="scope.row.orderItem.imgUrl" style="width:80px;">
                <div class="flex flex-justify-start flex-direction-col" style="margin-left: 15px">
                  <span>{{scope.row.orderItem.name}}</span>
                  <span>规格：{{scope.row.orderItem.spec}}</span>
                  <span>货号：{{scope.row.orderItem.skuCode}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="退货数量">
            <template slot-scope="scope">
              {{scope.row.returnQuantity}}
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            label="退款方式">-->
<!--            <template slot-scope="scope">-->
<!--              退至预付款-->
<!--            </template>-->
<!--          </el-table-column>-->

          <el-table-column
            label="退货金额">
            <template slot-scope="scope">
              {{scope.row.returnAmount | amount }}
              <el-tooltip class="item" effect="dark" content="退款金额=（销售价格-商品优惠）*数量" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            label="状态">-->
<!--            <template slot-scope="scope">-->
<!--              {{scope.row.status}}-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            label="积分扣除">-->
<!--            <template slot-scope="scope">-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
<!--        <div class="page tr">-->
<!--          <el-pagination-->
<!--            layout="prev, pager, next"-->
<!--            :total="sendTotal"-->
<!--            @current-change="changeSendPage">-->
<!--          </el-pagination>-->
<!--        </div>-->
      </div>
    </section>
    <section class="cons">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/user' }">用户中心</el-breadcrumb-item>
        <el-breadcrumb-item><router-link to="/user/molecular">擎科科邦邦商城订单</router-link></el-breadcrumb-item>
        <el-breadcrumb-item>擎科科邦邦商城订单详情</el-breadcrumb-item>
      </el-breadcrumb>
      <h3 class="title">擎科科邦邦商城订单详情<span :style="{fontSize: '14px', marginLeft: '20px', cursor: 'pointer'}"><a @click="viewContract">《服务协议》</a></span></h3>
      <ul class="text-lists">
        <li v-show="isHeadMan"><span>关联用户：</span>{{details.customer&&details.customer.realName}}</li>
        <li><span>订单创建者：</span>{{details.customer&&details.customer.realName}}</li>
        <li><span>订单号：</span>{{details.code}}</li>
        <li v-show="hidding"><span>订单创建时间：</span>{{details.createTime | rTime}}</li>
        <li v-show="hidding"><span>实验基地：</span>{{details.base&&details.base.name}}</li>
        <li v-show="hidding"><span>收货地址：</span>{{address}}</li>
        <li v-show="hidding"><span>订单状态：</span>{{details.statusName}}</li>
        <li v-show="hidding"><span>结算状态：</span>{{details.payStatusName}}</li>
        <li v-show="hidding"><span>订单总金额：</span>{{details.goodsAmount  | amount}} 元</li>
        <!-- <li v-show="hidding" v-if="details.promotionAmount > 0 || (details.totalStaffAdjustPriceDiscount!== 0)"><span>促销折扣金额：</span> -->
          <!-- {{details.promotionAmount+ (0-(details.totalStaffAdjustPriceDiscount / 1)) <= 0 ? '+' : '-'}}
          {{Math.abs(details.promotionAmount+ (0-(details.totalStaffAdjustPriceDiscount / 1))) | amount}} 元</li> -->
         <li v-show="hidding" v-if="details.promotionAmount > 0 "><span>促销折扣金额：</span>
          - {{details.promotionAmount | amount}}
        <li v-if="details.amount"><span>订单应付金额：</span>{{details.amount | amount}} 元</li>
        <li v-if="details.returnAmount"><span>订单退货金额：</span>{{details.returnAmount | amount}} 元</li>
        <li v-show="hidding"><span>已解锁积分：</span>{{details.unlockPoints}}<span v-if="details.totalDeductUnlockPoints > 0" :style="{color: '#FF2222', marginLeft: '5px'}">退货扣除：{{details.totalDeductUnlockPoints}}</span></li>
        <li v-show="hidding"><span>未解锁积分：</span>{{details.lockPoints}}<span v-if="details.totalDeductLockPoints > 0" :style="{color: '#FF2222', marginLeft: '5px'}">退货扣除：{{details.totalDeductLockPoints}}</span></li>
      </ul>
      <div class="hiddenBtn flex flex-justify-end">
        <el-button v-if="!hidding" icon="el-icon-arrow-down" circle @click="hidding = true"></el-button>
        <el-button v-if="hidding" icon="el-icon-arrow-up" circle  @click="hidding = false"></el-button>
      </div>
      <el-button type="primary" size="small" v-show="details.exchangeGoodsFlag" @click="exchangeOrder(details)">确认换货</el-button>
      <el-button type="primary" size="small" @click="confirmVisible"  v-show="details.statusName === '待确认' && memberInfo.id === details.customer.id">确认订单</el-button>
      <el-button type="primary" size="small" @click="cancelVisible"  v-show="['待确认','待审核'].indexOf(details.statusName) > -1 && memberInfo.id === details.customer.id">取消订单</el-button>
      <el-tooltip :content="content" placement="top" effect="light" :disabled="!details.exchangeGoodsFlag">
      <el-button type="primary" size="small" @click="sendVisible = true"  v-show="details.statusName === '部分发货' || details.statusName === '未发货' &&memberInfo.id === details.customer.id"
        :disabled="details.exchangeGoodsFlag">发货</el-button>
      </el-tooltip>
      <div style="margin-top: 10px;">注：客户应自收到发票之日起3个月内支付费用，双方有其他约定的以另行约定为准</div>

      <div >
        <table
          cellspacing= 0 cellpadding= 0
          :class="'productListTitle2'">
          <tr>
            <td>
              <div :style="{width: '100%'}">
                <span style="float: left;margin-left: 10px;cursor: pointer" @click="viewTable">
                  <i v-if="productTableShow" class="el-icon-arrow-down" />
                  <i v-else class="el-icon-arrow-right" />
                </span>
                <span>产品信息</span>
              </div>
            </td>
            <td :style="{width: '100px'}">单价</td>
            <td :style="{width: '80px'}">数量</td>
            <td :style="{width: '80px'}">未发货商品数量</td>
          </tr>
        </table>
      </div>
      <el-table
        v-show="productTableShow"
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
        :data="goodsLists"
        :showHeader="false"
      >
        <el-table-column
          prop="money"
          align="center"
          label="产品信息"
        >
          <template slot-scope="scope">
            <div class="product" style="display: block!important;">
              <div>
                <img :src="scope.row.imgUrl" style="width:80px;">
                <div v-if="scope.row.syzFlag / 1 === 1" class="redFlag">试用装</div>
                <div v-else-if="scope.row.price==0" class="redFlag">赠品</div>
              </div>

              <div class="info" style="text-align: center;margin-left: 0!important;">
<!--                <el-tooltip class="item" effect="dark" :content="scope.row.name"  placement="top-start">-->
<!--                  <div class="title" >{{scope.row.name}}</div>-->
<!--                </el-tooltip>-->
<!--                <p>规格：{{scope.row.spec}}</p>-->
                <p style="font-size: 12px;" v-if="scope.row.sku">{{scope.row.sku ? scope.row.sku.code : '-'}}</p>
                <p style="font-size: 12px;" v-else>{{scope.row.skuCode ? scope.row.skuCode: '-'}}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="100"
          label="单价">
          <template slot-scope="scope">{{scope.row.priceY | regDecimalPoint}}</template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="needPayQuantity"
          width="80"
          label="数量">
          <template slot-scope="scope">
            <div>{{scope.row.needPayQuantity}}</div>
            <div style="color: #FF2E2E;font-size: 12px" v-if="scope.row.postSaleQuantity">该商品已退货：{{scope.row.postSaleQuantity}}件</div>
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          align="center"-->
<!--          label="应付金额（元）">-->
<!--          <template slot-scope="scope">{{scope.row.amount | amount}}</template>-->
<!--        </el-table-column>-->
        <el-table-column
          align="center"
          width="80"
          label="未发货商品数量">
          <template slot-scope="scope">
            {{scope.row.needSendQuantity}}
          </template>
        </el-table-column>
      </el-table>
      <el-tabs v-model="activeName" style="margin-top:20px">
        <el-tab-pane v-for="(item, index) in tabPaneList" :key="index" :label="item.label" :name="item.name">
          <ExchangeRecordPhone v-show="item.name === '3'" :mallExchangeGoods="mallExchangeGoods"/>
        </el-tab-pane>
      </el-tabs>
      <!-- <h3 class="title distribution-title" @click="showDistribution = !showDistribution">配送记录<span class="el-icon-arrow-down" :class="{active: !showDistribution}"></span></h3> -->
      <div v-show="activeName === '1'">
        <el-table
          :data="sendLists"
          border>
          <el-table-column type="expand" width="50px">
            <template slot-scope="scope">
              <div class="goods-details">
                <div class="l-title">产品信息</div>
                <ul>
                  <li v-for="item in scope.row.items" :key="item.id">
                    <div class="img-box">
                      <img :src="item.imgUrl">
                    </div>
                    <div class="info">
                      <div class="title">{{item.goodsName}}</div>
                      <dl>
                        <dd><label>规格：</label>{{item.spec}}</dd>
                        <dd><label>商品数量：</label>{{item.quantity}}</dd>
                        <dd><label>货号：</label>{{item.skuCode}}</dd>
                        <dd><label>单位：</label>{{item.skuUnit}}</dd>
                      </dl>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="配送单号"
            width="260px"
            prop="code">
          </el-table-column>
          <el-table-column
            prop="sendStatusName"
            label="配送状态">
          </el-table-column>
          <el-table-column
            label="配送方式"
            prop="sendTypeName">
          </el-table-column>
          <el-table-column
            label="配送员/运单号">
            <template slot-scope="scope">
              <div v-if="scope.row.sendType !== 'DELIVERY'">{{scope.row.sender && scope.row.sender.realName}}</div>
              <div v-else>{{scope.row.deliveryCode}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="配送完成时间">
            <template slot-scope="scope">{{scope.row.finishSendDate | rTime}}</template>
          </el-table-column>
        </el-table>
        <div class="page tr">
          <el-pagination
            layout="prev, pager, next"
            :total="sendTotal"
            @current-change="changeSendPage">
          </el-pagination>
        </div>
      </div>
      <!-- <h3 v-if="returnList.length > 0" class="title distribution-title" @click="showReturned = !showReturned">退货记录<span class="el-icon-arrow-down" :class="{active: !showReturned}"></span></h3> -->
      <div v-show="activeName === '2'">
        <el-table
          :data="returnList"
          border>
          <el-table-column
            label="时间"
            width="180"
          >
            <template slot-scope="scope">
              {{scope.row.startDate | rTime}}
            </template>
          </el-table-column>
          <el-table-column
            label="产品信息"
            :min-width="320"
          >
            <template slot-scope="scope">
              <div class="flex flex-justify-start">
                <img :src="scope.row.orderItem.imgUrl" style="width:80px;">
                <div class="flex flex-justify-start flex-direction-col" style="margin-left: 15px">
                  <span>{{scope.row.orderItem.name}}</span>
                  <span>规格：{{scope.row.orderItem.spec}}</span>
                  <span>货号：{{scope.row.orderItem.skuCode}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="退货数量">
            <template slot-scope="scope">
              {{scope.row.returnQuantity}}
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            label="退款方式">-->
          <!--            <template slot-scope="scope">-->
          <!--              退至预付款-->
          <!--            </template>-->
          <!--          </el-table-column>-->

          <el-table-column
            label="退款金额">
            <template slot-scope="scope">
              {{scope.row.returnAmount | amount }}
              <el-tooltip class="item" effect="dark" content="退款金额=（销售价格-商品优惠）*数量" placement="top-end">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            label="状态">-->
          <!--            <template slot-scope="scope">-->
          <!--              {{scope.row.status}}-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column-->
          <!--            label="积分扣除">-->
          <!--            <template slot-scope="scope">-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>

      </div>
    </section>
    <!--发货弹出框-->
    <el-dialog
      title="商品提交发货"
      :visible.sync="sendVisible"
      width="60%">
      <el-table
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
        class="mt20"
        max-height="660"
        :data="goodsLists">
        <el-table-column
          prop="money"
          label="产品信息">
          <template slot-scope="scope">
            <div class="product">
              <img :src="scope.row.imgUrl" style="width:80px;">
              <div class="info">
                <div class="title">{{scope.row.name}}</div>
                <p>规格：{{scope.row.spec}}</p>
<!--                <p>货号：{{scope.row.sku.code}}</p>-->
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="未发货商品数量">
          <template slot-scope="scope">
            {{scope.row.needSendQuantity}}
          </template>
        </el-table-column>
        <el-table-column
          label="本次发货数量">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.sendNums" @change="changeSendNum($event, scope.$index)" controls-position="right" :min="0" :max="scope.row.needSendQuantity"></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendVisible = false">取消</el-button>
        <el-button type="primary" :disabled="saveStatus" :loading="saveStatus" @click="bindSend">{{saveStatus?'提交中':'提交发货'}}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="发货提示"
      :visible.sync="deliveryReminderDia"
      width="400px"
      center
      :before-close="()=>{deliveryReminderDia = false}">
      <span>温馨提示：您发货的商品 <span v-for="(ele,idx) in tradeNames" :key="idx">【{{ele}}】</span> 需要进行调货，擎小科将分2次给您配送，给您带来不便敬请谅解，如有问题请联系销售人员！</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deliveryReminderDia = false">关闭（{{colseTime}}s）</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { prodcutOrdersDetail, productOrdersSend, sendOrders, sendOrdersDetails, productOrderscancel, productOrdersConfirm, confirmExchangeGoods } from '@/services/api.index'
import { MessageBox } from 'element-ui';
import {
  tableHeaderStyle,
  tableCellStyle
} from '@/settings/table'
import ExchangeRecord from "./children/ExchangeRecord";
import ExchangeRecordPhone from "./children/ExchangeRecordPhone";
export default {
  components: {
    ExchangeRecord,
    ExchangeRecordPhone,
  },
  data () {
    return {
      content: '该订单换货信息尚未确认，请客户确认后再发货',
      tabPaneList: [
        { label: "配送记录", name: "1" },
        { label: "退货记录", name: "2" },
        { label: "换货记录", name: "3" },
      ],
      activeName: '1',
      productTableShow: true,
      rowClass: 'tableShow',
      hidding: false,
      showReturned: true,

      saveStatus: false,
      hidding: true,

      orderInfoList: [
      ],
      tableHeaderStyle,
      tableCellStyle,
      sendVisible: false,
      details: {},
      address: '',
      goodsLists: [],
      sendRecords: [],
      orderId: this.$route.query.id,
      showDistribution: true,
      sendLists: [],
      returnList: [],
      sendTotal: 0,
      sendPage: 0,
      sendSize: 10,
      isHeadMan: this.baseMethods.isHeadMan(),
      memberInfo: this.baseMethods.getLocalObj('memberInfo'),
      deliveryReminderDia: false,
      colseTime:3,
      deliveryRemindeTimer: null,
      mallExchangeGoods: [],
      loading: false,
    }
  },
  watch:{
    deliveryReminderDia(val){
       if(!val){
         clearInterval(this.deliveryRemindeTimer)
         this.colseTime = 3
       }
    }
  },
  created() {
    this.getDetails()
  },
  methods: {
    openSend (index) {
      this.sendVisible = true
      //sendVisible = true
    },
    viewTable () {
      this.productTableShow = !this.productTableShow
      this.$forceUpdate()
    },
    // 订单详情
    getDetails () {
      prodcutOrdersDetail(this.orderId).then(res => {
        let payStatusName = ''
        switch (res.data.payStatus) {
          case 'NO_BILL':
          case 'NO_PAY':
            payStatusName = '未结算'
            break
          case 'PAID':
            payStatusName = '已结算'
            break
        }
        res.data.statusName = this.baseMethods.molecularOrderStatus(res.data.webStatus)
        res.data.payStatusName = payStatusName
        this.details = res.data
        this.orderInfoList = [res.data]
        const address = res.data.address
        this.address = `${address.provinceName}${address.cityName}${address.areaName ? address.areaName : ''}${address.streetAddress}`
        res.data.items.map(item => {
          item.sendNums = 0
        })
        this.goodsLists = res.data.items
        console.info('POST SALES..', res)
        this.returnList = res.data.postSales
        const productList = []
        res.data.postSales.map((returnItem)=>{
          returnItem.items.map((item2)=>{
            item2.startDate = returnItem.startDate
            productList.push(item2)
          })
        })
        console.info('RETURN LIST DISPATCHED.',productList)
        this.returnList = productList
        this.mallExchangeGoods = res.data.mallExchangeGoods.sort((a, b) => {
            return new Date(b.createTime).getTime() - new Date(a.createTime).getTime()
        })
        this.getSendOrders()
      })
    },
    // 修改发货数量
    changeSendNum (value, index) {
      this.goodsLists[index].sendNums = value
      this.$set(this.goodsLists, index, this.goodsLists[index])
    },
    viewContract() {
      window.open(process.env.SHOP_URL + `/article/detail/14_0`)
    },
    confirmVisible() {
      MessageBox({
        title: '提示',
        message: '是否确认该笔订单？',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '执行中...'
            setTimeout(() => {
              done()
              setTimeout(() => {
                instance.confirmButtonLoading = false
              }, 300)
            }, 2000)
          } else {
            done()
          }
        }
      }).then(() => {
        productOrdersConfirm(this.orderId).then(() => {
          this.$message.success('订单确认成功！')
          this.$router.push('/user/molecular')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    cancelVisible() {
      const h = this.$createElement
      MessageBox({
        title: '提示',
        message: h('p', null, [
          h('h2',  {style:'text-align:center'}, '确定取消订单? '),
          h('div', {style:'text-align:center'}, '请谨慎操作'),
          h('div', {style:'text-align:center'}, '确定后，将取消订单，不可撤销'),
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            setTimeout(() => {
              done();
              setTimeout(() => {
                instance.confirmButtonLoading = false;
              }, 300);
            }, 2000);
          } else {
            done();
          }
        }
      }).then(() => {
        productOrderscancel(this.orderId).then(() => {
          this.$message.success('操作成功！')
          this.$router.push('/user/molecular')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    // 确认发货
    bindSend () {
      let items = []
      const sendGoods = this.goodsLists.filter(item => item.sendNums > 0)
      if (sendGoods.length === 0) {
        this.$message.error('请添加发货商品数量')
        return
      }
      this.goodsLists.map(item => {
        if (item.sendNums > 0) {
          items = items.concat({
            orderItemId: item.id,
            sendQuantity: Number(item.sendNums)
          })
        }
      })
      this.saveStatus = true
      productOrdersSend(this.orderId, items).then((res) => {
        if(res.data.orderItemNames && res.data.orderItemNames.length>0){
            this.tradeNames = res.data.orderItemNames
            this.deliveryReminder()
        }
        this.sendVisible = false
        this.saveStatus = false
        this.$message.success('提交发货成功！')
      })
    },
    deliveryReminder(){
      this.deliveryReminderDia = true
      this.colseTime = 3
      this.deliveryRemindeTimer = setInterval(()=>{
        this.colseTime -= 1
        if(this.colseTime==0){
          this.deliveryReminderDia = false
          clearInterval(this.deliveryRemindeTimer)
        }
      },1000)
    },
    // 配送记录
    getSendOrders () {
      const { sendPage, sendSize, details } = this
      sendOrders(sendPage, sendSize, details.code, false).then(async res => {
        await Promise.all(res.data.map(async item => {
          item.sendStatusName = this.baseMethods.sendStatus(item.sendStatus)
          item.sendTypeName = this.baseMethods.sendType(item.sendType)
          item.items = (await sendOrdersDetails(item.id)).data
        }))
        this.sendLists = res.data

        this.sendTotal = this.baseMethods.getTotal(res)
      })
    },
    // 翻页
    changeSendPage (value) {
      this.sendPage = value - 1
      this.getSendOrders()
    },
    async exchangeOrder({id}) {
      await this.$confirm("是否确认换货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      this.loading = true;
      try {
        await confirmExchangeGoods(id)
        this.$message.success('订单换货成功！')
      } catch (error) {
        this.$message.error(error.replace(/[^\u4e00-\u9fa5]/g, ''));
      }
      this.loading = false
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/molecular_details.vue